import { render, staticRenderFns } from "./TeacherRetrievePassEmail.vue?vue&type=template&id=321eb797&scoped=true"
import script from "./TeacherRetrievePassEmail.vue?vue&type=script&lang=js"
export * from "./TeacherRetrievePassEmail.vue?vue&type=script&lang=js"
import style0 from "./TeacherRetrievePassEmail.vue?vue&type=style&index=0&id=321eb797&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321eb797",
  null
  
)

export default component.exports